var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { UPDATE_LR_POST_REQUEST, UPDATE_LR_POST_SUCCESS, UPDATE_LR_POST_ERROR } from '../actions/updateLongReadPost';
var initialState = {
    isFetching: false,
    isError: false,
    data: {}
};
export function updateLongReadPostReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case UPDATE_LR_POST_REQUEST:
            return __assign(__assign({}, state), { isFetching: true });
        case UPDATE_LR_POST_SUCCESS:
            return __assign(__assign({}, state), { isFetching: false, data: action.payload.data });
        case UPDATE_LR_POST_ERROR:
            return __assign(__assign({}, state), { isFetching: false, isError: true });
        default:
            return state;
    }
}
;
//# sourceMappingURL=updateLongReadPost.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { UPDATE_LR_POST_REQUEST, UPDATE_LR_POST_SUCCESS, UPDATE_LR_POST_ERROR } from '../actions/updateLongReadPost';
var initialState = {
    isFetching: false,
    isError: false,
    data: {}
};
export function updateLongReadPostReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case UPDATE_LR_POST_REQUEST:
            return __assign(__assign({}, state), { isFetching: true });
        case UPDATE_LR_POST_SUCCESS:
            return __assign(__assign({}, state), { isFetching: false, data: action.payload.data });
        case UPDATE_LR_POST_ERROR:
            return __assign(__assign({}, state), { isFetching: false, isError: true });
        default:
            return state;
    }
}
;
//# sourceMappingURL=updateLongReadPost.js.map